// 통화 데이터 (거래/교환 탭 공용)
export const currencies = [
  { code: 'USD', countryCode: 'us', name: '미국 달러' },
  { code: 'CNY', countryCode: 'cn', name: '중국 위안' },
  { code: 'JPY', countryCode: 'jp', name: '일본 엔' },
  { code: 'EUR', countryCode: 'eu', name: '유로' },
  { code: 'MYR', countryCode: 'my', name: '말레이시아 링깃' },
  { code: 'AUD', countryCode: 'au', name: '호주 달러' },
  { code: 'CAD', countryCode: 'ca', name: '캐나다 달러' },
  { code: 'VND', countryCode: 'vn', name: '베트남 동' },
  { code: 'IDR', countryCode: 'id', name: '인도네시아 루피아' },
  { code: 'HKD', countryCode: 'hk', name: '홍콩 달러' },
  { code: 'TWD', countryCode: 'tw', name: '대만 달러' },
  { code: 'SGD', countryCode: 'sg', name: '싱가포르 달러' },
  { code: 'THB', countryCode: 'th', name: '태국 바트' },
  { code: 'PHP', countryCode: 'ph', name: '필리핀 페소' },
  { code: 'GBP', countryCode: 'gb', name: '영국 파운드' },
]

// 통화별 최소 거래 단위 (매각/교환 시 외화 금액 내림 단위)
export const CURRENCY_MIN_UNITS: Record<string, number> = {
  USD: 5,
  JPY: 1000,
  CNY: 5,
  EUR: 5,
  MYR: 10,
  AUD: 10,
  CAD: 10,
  VND: 100000,
  IDR: 100000,
  HKD: 100,
  TWD: 1000,
  SGD: 100,
  THB: 1000,
  PHP: 1000,
  GBP: 10,
}

// 원화 100원 단위 반올림 (거래 계산 공통 규칙)
export const roundKRW = (n: number) => Math.round(n / 100) * 100
